import { auth } from '@/shared/lib';
import classNames from 'classnames';
import type { ReportsTabProps } from './reportsTab.types';
import './reportsTab.scss';
import ReportsTable from './reportsTable/reportsTable';

const ReportsTab = ({
  isLoadedData,
  data,
  toggleInboxECGViewer,
  updateData,
  hasLoginBanner,
  shouldLoadVerifiedReport,
  resetShouldLoadVerifiedReport,
}: ReportsTabProps) => (
  <div
    className={classNames('reports-tab animated fadeIn', {
      'has-marketing-banner': auth.hasMarketingBanner() || auth.hasLogoBanner(),
      'has-login-banner': hasLoginBanner,
    })}
  >
    <ReportsTable
      isLoadedData={isLoadedData}
      data={data}
      toggleInboxECGViewer={toggleInboxECGViewer as any}
      updateData={updateData}
      shouldLoadVerifiedReport={shouldLoadVerifiedReport}
      resetShouldLoadVerifiedReport={resetShouldLoadVerifiedReport}
    />
  </div>
);

export default ReportsTab;
